import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, message } from 'kenshin';
import {
  CloseOutlined,
  DownloadOutlined,
  CopyOutlined,
  StarOutlined,
  EditOutlined,
  ExpandOutlined,
  EraserOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  RedoOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import './index.less';

const ImagePreview = ({
  images,
  initialIndex = 0,
  onClose,
  onAddToConversation,
}) => {
  // 当前选中的图片索引
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  // 缩放相关状态
  const [scale, setScale] = useState(1);
  const scaleRef = useRef(1);

  // 确保 images 是数组且有内容
  const imageList = Array.isArray(images) ? images : [images];
  const currentImage = imageList[currentIndex] || imageList[0];

  // 操作按钮配置
  const actionButtons = [
    {
      label: '添加到对话',
      icon: <PlusCircleOutlined />,
      action: () => {
        if (onAddToConversation) {
          onAddToConversation(currentImage);
          onClose();
        }
      },
      primary: true,
    },
    // { label: '生成视频', icon: <VideoCameraOutlined />, action: () => {} },
    // { label: '超清', icon: <ExpandOutlined />, action: () => {} },
    // { label: 'AI改图', icon: <EditOutlined />, action: () => {} },
    // { label: '扩图', icon: <ExpandOutlined />, action: () => {} },
    // { label: '消除', icon: <EraserOutlined />, action: () => {} },
    // { label: '下载', icon: <DownloadOutlined />, action: () => {} },
    // { label: '重新生成', icon: <RedoOutlined />, action: () => {} },
  ];

  // 主图容器 ref，用于绑定原生 wheel 监听
  const mainImageRef = useRef(null);

  // 鼠标滚轮缩放
  const handleWheel = useCallback((e) => {
    // React 的 onWheel 是 passive 监听，无法 preventDefault，
    // 这里通过原生非 passive 绑定来拦截页面滚动
    e.preventDefault();
    e.stopPropagation();

    const step = e.deltaY > 0 ? -0.1 : 0.1;
    // 限制缩放范围 0.5 ~ 5 倍
    const next = Math.min(5, Math.max(0.5, scaleRef.current + step));
    scaleRef.current = parseFloat(next.toFixed(2));
    setScale(scaleRef.current);
  }, []);

  // 用原生 addEventListener 绑定，避免 passive 报错
  useEffect(() => {
    const el = mainImageRef.current;
    if (!el) return;
    el.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      el.removeEventListener('wheel', handleWheel);
    };
  }, [handleWheel]);

  // 点击缩略图切换主图
  const handleThumbClick = (idx) => {
    setCurrentIndex(idx);
    // 切换图片时重置缩放
    scaleRef.current = 1;
    setScale(1);
  };

  return (
    <div className="imagePreviewOverlay" onClick={onClose}>
      <div className="imagePreviewContent" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <div className="closeBtn" onClick={onClose}>
          <CloseOutlined />
        </div>

        {/* 返回按钮 */}
        {/* <Button className="backBtn" onClick={onClose}>
          返回对话
        </Button> */}

        {/* 主图 */}
        <div className="mainImage" ref={mainImageRef}>
          <img
            src={currentImage}
            alt="预览图片"
            style={{
              transform: `scale(${scale})`,
              transition: 'transform 0.15s ease',
            }}
          />
          {scale !== 1 && (
            <div className="zoomTip">{Math.round(scale * 100)}%</div>
          )}
        </div>

        {/* 右侧操作区 */}
        <div className="sidePanel">
          {/* 缩略图列表 */}
          {imageList.length > 0 && (
            <div className="thumbList">
              {imageList.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt=""
                  className={`thumbItem ${
                    idx === currentIndex ? 'active' : ''
                  }`}
                  onClick={() => handleThumbClick(idx)}
                />
              ))}
            </div>
          )}

          {/* 操作按钮 */}
          <div className="actionButtons">
            {actionButtons.map((btn, idx) => (
              <Button
                key={idx}
                className={`actionBtn ${btn.primary ? 'actionBtnPrimary' : ''}`}
                onClick={btn.action}
                icon={btn.icon}
              >
                {btn.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
